export default function ({ app, $axios, redirect }) {
    $axios.onError(error => {
        const code = parseInt(error.response && error.response.status)

        console.error(`Code: ${code}  | Response: ${JSON.stringify(error.response)}`);

        if(code !== 403){
            fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ title: `Axios Error: ${code} - ${JSON.stringify(error.response)}`, message: `${JSON.stringify(error.response)} - ${location.href} `, sound: 'mechanical' })
            });
        }

        if (code === 400) {
            redirect('/error?message='+(error.response.data.error??error.response.data.message));
        }

        if (code === 404) {
            redirect('/404');
        }
    })
}
